import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  back: {
    id: 'back',
    defaultMessage: 'Back',
  },
  transactionDetails: {
    id: 'transactionDetails',
    defaultMessage: 'Transaction details',
  },
  childTrs: {
    id: 'childTrs',
    defaultMessage: 'Child transactions',
  },
  parentTrs: {
    id: 'parentTrs',
    defaultMessage: 'Parent transaction',
  },
  trsDetails: {
    id: 'trsDetails',
    defaultMessage: 'Transaction details',
  },
  trsId: {
    id: 'trsId',
    defaultMessage: 'Transaction ID',
  },
  trsRef: {
    id: 'trsRef',
    defaultMessage: 'Transaction reference',
  },
  accountAmount: {
    id: 'accountAmount',
    defaultMessage: 'Account amount',
  },
  accountHoldAmount: {
    id: 'accountBalance',
    defaultMessage: 'Account hold amount',
  },
  availableAmount: {
    id: 'availableAmount',
    defaultMessage: 'Available amount',
  },
  minLimit: {
    id: 'minLimit',
    defaultMessage: 'Min. Limit',
  },
  maxLimit: {
    id: 'maxLimit',
    defaultMessage: 'Max. Limit',
  },
});

export default { ...globalIntl, ...m };
